
<template>
	<div :class="columnClass">
        <div v-if="columnLabel=='employee_name'" class="table-td-border-right">
            <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">

                <div class="o-accordion-subtext o-rowtable-text">

                    <div>{{(selectedSortType=='fname_asc')?employee.first_name+" "+employee.last_name : employee.last_name+", "+employee.first_name}}</div>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.employee_seniority) || 0}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='skill_seniority'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.skill_seniority) || 0 }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shifts || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_total'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd_july_june'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='decline_this_week'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipation(employee.participation)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation_july_june_desc'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipationJulyJune(employee.participation_july_june)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_offer'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_offer ? getGloabalDateTimeFormat(employee.last_offer) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_assigned'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_assigned ? getGloabalDateTimeFormat(employee.last_assigned) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_confirmed'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.last_confirmed ? getGloabalDateTimeFormat(employee.last_confirmed) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='member_since'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.member_since ? getGloabalDateFormat(employee.member_since) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='date_of_hire'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <!-- {{ employee.employee_date_of_hire }} -->
                <div>{{employee.date_of_hire ? getGloabalDateFormat(employee.date_of_hire) : ""}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='location'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.address || '- - -'}}</div>
                <!-- <div>Add Location</div> -->
            </div>
        </div>

        <div v-if="columnLabel=='wishlist'" class="table-td-border-right calls-table-cell-inner-table">
            <div class="o-accordion-subtext o-rowtable-text">
                <span>
                    Wishlist:
                    <el-tooltip v-if="employee.wishlist&&employee.wishlist.length&&employee.wishlist[0].employee_message" class="item" effect="light" :content="employee.wishlist[0].employee_message" placement="top-end">
                        <i :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W') ? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                    </el-tooltip>
                    <i v-else-if="employee.wishlist&&employee.wishlist.length" :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W')? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i>
                </span>
                <div>{{(employee && employee.wishlist.length)? getTimeStampValue(employee.wishlist[0].wishlist_timing):''}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field1'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field1)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field2'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field2)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_cell_phone'" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>
                    <a :href="'tel:'+getClientContactFormat(employee.phone_number)" class="phone-number-display">
                        {{ employee.phone_number ? getClientContactFormat(employee.phone_number) : '' }}
                    </a>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='conflicts'">
            <!-- #1661 (job-details render) — the resolver drives ONLY the four COMMITMENT states here;
                 everything else falls through to production's existing paths below, so each state has
                 exactly one render path (collapses the "Vacation" vs "Unavailable due to vacation"
                 double-render MR !426 left behind).
                 ed's complaint was the ABSTRACT WORDS: a bare red "Offered" pill tells the dispatcher
                 nothing — they need WHICH JOB. The detail is already on the row
                 (employee.conflict.primary.detail = {call_id, job_number, job_title, start, end}, built
                 by AvailabilityCheck::computeElsewhereCommitments); this renders it.
                 Mapping (commitmentRender): here=BLUE, elsewhere=RED, [C] prefix on the two CONFIRMED
                 reasons only. Colour is keyed off the REASON per ed's spec, not the resolver's
                 .color — resolveColor currently reds offered_here via RED_PRECEDENCE, but ed's spec is
                 "here=blue"; reconciling the resolver colour is a separate backend concern.
                 Non-commitment states (vacation / recurring / HTS / called-out / passed / timed-out /
                 declined / available) are NOT matched here and render via the production branches that
                 already carry their exact wording + job details. -->
            <div v-if="commitmentRender(employee)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)"
                               :class="'c-tag-btn ' + commitmentRender(employee).colorClass"
                               :title="conflictHover(employee.conflict)">
                                {{ commitmentRender(employee).text }}
                                <i v-if="employee.conflict.star" class="fa fa-star" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li v-if="allowReassign && employee.conflict.primary.action === 'unassign_reassign_here'" class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red" @click="unassignReassignHere(employee)">Unassign &amp; reassign here</a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- #1661 (resync blocker) — vacation / RU render from the resolver's PER-DAY
                 employee.conflict, NOT the legacy envelope field. checkVacationWithinCall /
                 recurringUnavailability read the whole-run ENVELOPE, so on a month-long job they
                 over-blocked anyone with a vacation anywhere in the month (Abby Hammer: Jul-24–31
                 vacation flagged "vacation" on a Jul-23 call — grid disagreed with the eyeball,
                 which is per-day). conflictHardVacationRU() derives the exact production wording
                 from the resolver's per-day vacation/recurring reasons; if the resolver says green
                 for the day, this returns null and the row falls through to the gap pills. RED,
                 hard block, per the ratified map. The legacy envelope branch is deleted, and its
                 gate is removed from the fall-through branches below. -->
            <div v-else-if="conflictHardVacationRU(employee)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
                                {{ conflictHardVacationRU(employee) }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="employee.bookings.length == 0 && !getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">

                    <ul v-if="!employee.previous_calls&&!employee.next_calls" class="o-tag-btn-area o-float-right">
                        <li class="">
                            <a href="javascript: void(0)" class="o-half-div" :class="gapPillBlue(employee) ? 'c-tag-btn u-btn-blue' : 'c-tag-btn u-btn-green'">
                                Last call: 24:00+
                            </a>
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" v-if="employee.hts&&employee.hts.length && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job" class="o-half-div c-tag-btn u-btn-light-orange">
                                {{ getJobTitle(employee.hts) }}
                            </a>
                            <a href="javascript: void(0)" class="o-half-div" :class="gapPillBlue(employee) ? 'c-tag-btn u-btn-blue' : 'c-tag-btn u-btn-green'">
                                Nex call: 24:00+
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">

                        <li v-if="Object.keys(employee.previous_calls).length==0" :class="{'o-half-div': true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="{'c-tag-btn u-btn-blue': gapPillBlue(employee), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job)}">Last call: 24:00+</a>
                        </li>

                        <li v-if="Object.keys(employee.previous_calls).length!=0" :class="{'o-half-div': true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="{'c-tag-btn u-btn-blue': gapPillBlue(employee), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !checkTurnOver(employee.previous_calls) && !employee.confirmed_on_this_job), 'c-tag-btn u-btn-yellow':(Object.keys(employee.hts).length==0 && checkTurnOver(employee.previous_calls) && !employee.confirmed_on_this_job),'u-btn-border-red':checkPrevNextCallSameDay(employee.prev_Call)}">
                                {{ getPrevCallTime(employee.previous_calls) }}
                            </a>
                        </li>

                        <li v-if="employee.hts&&employee.hts.length && !isCurrentJobHTS(employee.hts)" class="o-half-div o-half-div-width">   
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" class="c-tag-btn u-btn-light-orange">
                                {{getJobTitle(employee.hts)}}
                            </a>
                        </li>

                        <li v-if="employee.next_calls&&Object.keys(employee.next_calls).length==0" :class="{'o-half-div':  true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="{'c-tag-btn u-btn-blue': gapPillBlue(employee), 'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job), 'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !employee.confirmed_on_this_job),'c-tag-btn u-btn-yellow1':(employee.next_vacation.length&&employee.next_vacation[0].vacation_interval)}">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{getNextVacationTime(employee.next_vacation)}}
                                </span>
                                <span v-else>Next call: 24:00+</span>
                            </a>
                        </li>

                        <li v-if="Object.keys(employee.next_calls).length!=0" :class="{'o-half-div':  true, 'o-half-div-width': !isCurrentJobHTS(employee.hts)}">
                            <a href="javascript: void(0)" :title="htsHoverTitle(employee)" :class="{'c-tag-btn u-btn-blue': gapPillBlue(employee),'c-tag-btn u-btn-light-orange':(Object.keys(employee.hts).length>0 && !isCurrentJobHTS(employee.hts) && !employee.confirmed_on_this_job),'c-tag-btn u-btn-green':(Object.keys(employee.hts).length==0 && !checkTurnOver(employee.next_calls) && !employee.confirmed_on_this_job),'c-tag-btn u-btn-yellow':(Object.keys(employee.hts).length==0 && checkTurnOver(employee.next_calls) && !employee.confirmed_on_this_job),'c-tag-btn u-btn-yellow1':(employee.next_vacation.length&&employee.next_vacation[0].vacation_interval),'u-btn-border-red':checkPrevNextCallSameDay(employee.next_Call)}">
                                <span v-if="employee.next_vacation.length&&employee.next_vacation[0].vacation_interval">
                                    {{ getNextCallTime(employee.next_calls) }} <br />
                                    {{ getNextVacationTime(employee.next_vacation) }}
                                </span>
                                <span v-else>{{ getNextCallTime(employee.next_calls) }} </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="employee.bookings.length>0" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" v-if="!checkAssignedJob(employee)">
                            <a href="javascript: void(0)" :class="checkThisClickCooking(employee.bookings)?'c-tag-btn u-btn-orange':'c-tag-btn u-btn-red'">
                            {{checkThisClickCooking(employee.bookings)?employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')':'OTHER BOOKING'}}
                            </a>
                        </li>

                        <li class="o-half-div" v-else>
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-blue">
                            {{employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')'}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="getDeclineStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" @click="openDeclinedModal(employee)">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
                                Declined : {{getCallActionByType(employee.call_actions, "Declined")[0].job_name}}
                            </a>
                        </li>
                    </ul>

                    <!-- #1690 T5b — no-show / sent-home: YELLOW, re-offerable "no" family, no assign
                         tool. The slot was cleared and this is the logged record (also on the decline tab). -->
                    <ul v-else-if="getNoShowSentHomeStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">
                                {{ getNoShowSentHomeLabel(employee.call_actions) }}
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getCallOutStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">
                                Called Out : {{getCallActionByType(employee.call_actions, "Call Out")[0].job_name}}
                            </a>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getTimeOutStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <el-tooltip content="Declined Schedule" placement="top" effect="dark">
                                <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow" @click="openTimedOutModal(employee)">
                                    Timed Out : {{getCallActionByType(employee.call_actions, "Timed Out")[0].job_name}}
                                </a>
                            </el-tooltip>
                        </li>
                    </ul>

                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <el-tooltip content="Declined Schedule" placement="top" effect="dark">
                                <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow" @click="openPassedModal(employee)">
                                    Passed : {{getCallActionByType(employee.call_actions, "Passed")[0].job_name}}
                                </a>
                            </el-tooltip>
                        </li>
                    </ul>

                </div>
            </div>
        </div>

        <el-dialog title="Schedule" width="85%" :close-on-click-modal="false" custom-class="pass-time-out-modal" :visible.sync="dialogPassedVisible">
            <ScheduleModal :routeEmployeeId="routeEmployeeId" v-if="routeEmployeeId==employee.id" />
        </el-dialog>

        <el-dialog title="Schedule" width="85%" :close-on-click-modal="false" custom-class="pass-time-out-modal" :visible.sync="dialogTimeOutVisible">
            <ScheduleModal :routeEmployeeId="routeEmployeeId" v-if="routeEmployeeId==employee.id" />
        </el-dialog>
	</div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import ScheduleModal from '@/components/scheduleModal.vue';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../../global.js';
    import { bus } from '../../../main';
    import service from '../../../services.js';
    export default {
        props: {
            // #1661 — only the single-call assign grid has a single "here" call to
            // reassign onto, so only it opts into the recoverable-red reassign control.
            // Bulk (multi-call) shows the color badge without the action.
            allowReassign: {
                type: Boolean,
                required: false,
                default: false
            },
            isSteward: {
                type: Number,
                required: true
            },
            isDispatcher: {
                type: Number,
                required: true
            },
            employee: {
                type: Object,
                required: true
            },
            columnLabel: {
                type: String,
                required: true
            },
            client:{
                type: Object,
                required: true
            },
            selectedSortType:{
                type: String,
                required: true
            },
            callStartTime:{
                type:String,
                required: true
            },
            callEndTime:{
                type:String,
                required: true
            },
            userDateFormat: {
                type:String,
                required: false
            },
            userTimeFormat: {
                type:String,
                required: false
            }
        },
        data() {
            return {
               columnClass:'',
               turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                address:'',
                routeEmployeeId: '',
                modalActionName: '',
                dialogTimeOutVisible: false,
                dialogPassedVisible: false
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                employeeId: "employeeId",
                bulkCallStartTime: 'bulkCallStartTime',
                bulkCallEndTime: 'bulkCallEndTime'
            })
        },
        components: {
            ScheduleModal
        },
        methods: {
            // #1661 — five-color conflict badge from the resolver's `conflict` field.
            conflictBtnClass(color) {
                const map = {
                    green:  'u-btn-green',
                    yellow: 'u-btn-yellow',
                    orange: 'u-btn-orange',
                    red:    'u-btn-red',
                    blue:   'u-btn-blue',
                };
                return map[color] || 'u-btn-green';
            },
            gapPillBlue(employee) {
                // #1661 — a "Last/Next call" gap pill is BLUE when the candidate is tied to THIS
                // job: an HTS hold on this job (production's existing signal) OR already CONFIRMED
                // on this job on another call/day (employee.confirmed_on_this_job, backend). Blue =
                // "already on the job, re-assignable"; green = a fresh candidate. Blue wins over
                // green / yellow / light-orange, mirroring how isCurrentJobHTS already behaves.
                var htsOnThisJob = employee.hts && Object.keys(employee.hts).length > 0 && this.isCurrentJobHTS(employee.hts);
                return !!(htsOnThisJob || employee.confirmed_on_this_job);
            },
            conflictHardVacationRU(employee) {
                // #1661 (resync blocker) — the cell's vacation/RU state, sourced from the
                // resolver's PER-DAY employee.conflict, NOT the legacy envelope field. Returns the
                // exact production wording when the resolver's primary (per-day) is a hard
                // vacation/recurring block, else null (→ the row falls through to the gap pills).
                // Vacation always outranks yellow/orange in the resolver, and a red booking that
                // outranks vacation is already rendered by commitmentRender (branch 1) — so this is
                // reached only when vacation/recurring IS the displayed per-day state. `others`
                // carries the second reason for the combined phrase.
                const c = employee && employee.conflict;
                const p = c && c.primary;
                const others = c && c.others ? c.others.map((o) => o && o.reason) : [];
                const reasonVac = !!(p && p.reason === 'vacation') || others.indexOf('vacation') !== -1;
                const reasonRU  = !!(p && p.reason === 'recurring') || others.indexOf('recurring') !== -1;
                // #1690 T4 — the pill must be RED wherever the assign tool is hard-blocked,
                // never green-with-no-tool (Ed q2). The tool (single/bulk assignHardBlocked)
                // disables on the FRONTEND per-day recurring-unavailability check
                // recurringUnavailability(available_times) — the resolver's per-day 'recurring'
                // reason does not always cover the #1680 overnight-window nuance, so a worker
                // could show green here yet have no assign tool. Mirror the SAME check so the
                // two agree: red pill ⇔ blocked tool.
                const hasVac = reasonVac;
                const hasRU  = reasonRU || this.recurringUnavailability(employee.available_times);
                if (!hasVac && !hasRU) {
                    return null;
                }
                if (hasVac && hasRU) {
                    return 'Unavailable due to vacation and recurring unavailability';
                }
                return hasVac
                    ? 'Unavailable due to vacation'
                    : 'Unavailable due to recurring unavailability';
            },
            commitmentRender(employee) {
                // #1690 (ratified 2026-08-11) — for the four COMMITMENT reasons, return the
                // pill to render: { colorClass, text }. Returns null for every other state so
                // the template falls through to the existing branches (vacation/RU/HTS/called-
                // out/passed/timed-out/declined/available) — one render path per state.
                //
                // Pill COLOUR is taken from the resolver's .color — the SINGLE SOURCE OF TRUTH
                // (Ed's ruling: booked-elsewhere is RED, not orange; only the resolver decides
                // colour). Markers are SEMANTIC, keyed off the reason, and ride on top of colour:
                //   [C] = confirmed  → confirmed_here (blue) + booked_confirmed_elsewhere (red)
                //   [U] = unconfirmed here → offered_here (red)
                const COMMITMENT = ['confirmed_here', 'booked_confirmed_elsewhere', 'booked_offered_elsewhere', 'offered_here'];
                const colorClassByColor = { blue: 'u-btn-blue', red: 'u-btn-red', orange: 'u-btn-light-orange', yellow: 'u-btn-yellow', green: 'u-btn-green' };
                const markerByReason = { confirmed_here: '[C] ', booked_confirmed_elsewhere: '[C] ', offered_here: '[U] ' };

                const primary = employee && employee.conflict && employee.conflict.primary;
                if (!primary || COMMITMENT.indexOf(primary.reason) === -1) return null;

                const d = primary.detail || {};
                const title = d.job_title ? String(d.job_title).trim() : '';
                const number = (d.job_number !== undefined && d.job_number !== null && d.job_number !== '')
                    ? '#' + d.job_number
                    : '';
                // Job name + number. Fall back to the resolver label only if the detail is missing
                // entirely, so the pill is never blank (should not happen — detail is always built
                // for these reasons — but a missing detail must not render an empty pill).
                let job = [title, number].filter(Boolean).join(' ').trim();
                if (!job) job = primary.label || '';

                return {
                    colorClass: colorClassByColor[primary.color] || 'u-btn-red',
                    text: (markerByReason[primary.reason] || '') + job,
                };
            },
            conflictSignalLine(sig) {
                if (!sig) return '';
                let line = sig.label || sig.reason || '';
                const d = sig.detail;
                if (d && d.job_number) {
                    line += ': #' + d.job_number + (d.job_title ? ' ' + d.job_title : '');
                }
                return line;
            },
            conflictHover(conflict) {
                if (!conflict) return '';
                const lines = [];
                if (conflict.primary) lines.push(this.conflictSignalLine(conflict.primary));
                (conflict.others || []).forEach((o) => lines.push(this.conflictSignalLine(o)));
                return lines.join('\n');
            },
            unassignReassignHere(employee) {
                // Recoverable red (booked elsewhere): unassign the elsewhere call and
                // reassign to this call. Emitted for the parent grid to run the
                // existing assign flow against the conflict detail.
                this.$emit('unassign-reassign-here', {
                    employee: employee,
                    conflict: employee.conflict,
                });
            },
            openPassedModal(employee) {
                this.routeEmployeeId = employee.id;
                this.modalActionName = 'passed';
                this.$forceUpdate();
                this.dialogPassedVisible = true;
            },
            closeModal(name) {
                this.modalActionName='';
                this.dialogPassedVisible = false;
                this.dialogTimeOutVisible = false;
                this.routeEmployeeId = '';
            },
            openTimedOutModal(employee) {
                this.routeEmployeeId=employee.id;
                this.modalActionName='timed-out';
                this.$forceUpdate();
                this.dialogTimeOutVisible = true;
            },
            checkPrevNextCallSameDay(dateTime) {
                let prevDate = moment(dateTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                let callStartDate = '';
                let callEndDate = '';
                if(this.$route.name == 'bulkAssignCustom') {
                    callStartDate = moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                    callEndDate = moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                }else {
                    callStartDate = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                    callEndDate = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                }
                if(prevDate==callStartDate||prevDate==callEndDate) {
                    return true;
                }
                return false;
            },
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) {
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
            },
            getRoundOffSkillSeniority(seniorityVal) {
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            async openDeclinedModal(emp) {
                if((this.userRoleSlug != 'employee') || (this.userRoleSlug == 'employee' && (this.isDispatcher || this.isSteward))) {
                    await this.$confirm('Do you want to Un-Decline', 'Un-Decline?', {
                    confirmButtonText: 'Undecline',
                    cancelButtonText: 'Cancel',
                    }).then(async () => {
                        await this.undeclinedCall(emp);
                    }).catch(() => {});
                }
            },

            async undeclinedCall(emp) {
                await service.post('call/undecline', {
                    'employee_id': emp.id,
                    'call_id': this.getDeclinedCallId(emp.call_actions),
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    let action = 'Decline'
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'Call undeclined successfully.',
                        type: 'success'
                    });
                    bus.$emit('callUnDecline', action );
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'Warning',
                        message: 'Call undeclined Failed.',
                        type: 'warning'
                    });
                    this.$Progress.finish();
                });
            },

            getDeclinedCallId(data) {
                let call_id = data[0].call_id;
                if(data.length > 1) {
                    for(let i=0; i<data.length; i++) {
                        if(data[i].action_name == "Declined") {
                            call_id = data[i].call_id
                        }
                    }
                }
                return call_id;
            },

            isCurrentJobHTS(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                let flag=false;
                hts_list.forEach(hts => {
                    if(hts.job_id == atob(this.$route.params.id)){
                        flag=true;
                    }
                });
                return flag;
            },
          
            isCurrentHTSJob(hts_job_id) {
                if (hts_job_id == atob(this.$route.params.id)) {
                    return true;
                }
                return false;
            },

            getJobTitle(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                return (hts_list && hts_list.length? hts_list[0].job_name :'');
            },
            // #1690 T3 — HTS hover: name the job the soft-hold (possible conflict) is on.
            // The Last/Next-call gap pills go ORANGE when the worker is HTS-held on ANOTHER
            // job but show only a time — so on hover, name that job (Ed: "orange shows the
            // job name of the possible conflict"). Empty when not an elsewhere HTS hold, so
            // no stray tooltip on green/blue pills.
            htsHoverTitle(employee){
                if (employee && employee.hts && Object.keys(employee.hts).length > 0 && !this.isCurrentJobHTS(employee.hts)) {
                    const name = this.getJobTitle(employee.hts);
                    return name ? ('HTS hold on ' + name) : 'HTS hold on another job';
                }
                return '';
            },
            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [], noShows = [], sentHomes = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            case 'Declined':
                                declines.push(call);
                            break;
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            case 'Passed':
                                passes.push(call);
                            break;
                            // #1690 T5b — no-show / sent-home ride the decline tab but
                            // render YELLOW on the grid (Status.name: "No-show" / "Sent Home").
                            case 'No-show':
                                noShows.push(call);
                            break;
                            case 'Sent Home':
                                sentHomes.push(call);
                            break;

                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    case 'Declined':
                        return declines;
                    case 'Call Out':
                        return callouts;
                    case 'Timed Out':
                        return timeouts;
                    case 'Passed':
                        return passes;
                    case 'No-show':
                        return noShows;
                    case 'Sent Home':
                        return sentHomes;
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },
            // #1690 T5b — a no-show / sent-home logged for this worker. Renders YELLOW
            // ("No-show" / "Sent Home", re-offerable "no" family) and blocks the assign
            // tool. The recorded status IS the record (logged on the decline tab).
            getNoShowSentHomeStatus(call_actions){
                return this.getCallActionByType(call_actions, "No-show").length > 0
                    || this.getCallActionByType(call_actions, "Sent Home").length > 0;
            },
            getNoShowSentHomeLabel(call_actions){
                const ns = this.getCallActionByType(call_actions, "No-show");
                if (ns.length) return 'No-show : ' + ns[0].job_name;
                const sh = this.getCallActionByType(call_actions, "Sent Home");
                if (sh.length) return 'Sent Home : ' + sh[0].job_name;
                return '';
            },
            checkThisClickCooking(bookings,conflicts){
               if(conflicts) {}
               if(bookings.length>0 && bookings[0].client_id == this.userClientID){
                    return true;
                }
                return false;
            },

            checkAssignedJob(employee) {
                let bookings = employee.bookings;
                if(bookings.length>0 && bookings[0].client_id == this.userClientID &&  bookings[0].job_id == atob(this.$route.params.id)){
                    return true;
                }
                return false;
            },

            getParticipation(data){
                var result = 0;
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getParticipationJulyJune(data){
                var result = 0;
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0)){
                    return true;
                }
                return false;
            },

            getTimeStampValue(data){
                if(data)  return dateTimeConvert.utcTimeToUserTime(data);
                return '- - -';
            },

            getTimeStamp(data){
                if(data)  return moment(data).format('MM/DD/YYYYY @HH:mm:ss');
                return '- - -';
            },

            getGloabalDateTimeFormat(data) {
                if (!data || data === "0000-00-00 00:00:00" || isNaN(new Date(data).getTime())) {
                    return ""; 
                }
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },

            getGloabalDateFormat(data) {
                if (!data || data === "0000-00-00 00:00:00" || isNaN(new Date(data).getTime())) {
                    return "";
                }
                return dateTimeConvert.globalDate2(data,this.userDateFormat);
            },

            getPassStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Passed");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getTimeOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Timed Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },

            getCustomField(data) {
                var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value)
                {
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        inner = JSON.parse(customFld.value);
                        if(inner&&inner != ''&&inner.value)
                            re2 = customFld.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '';
                        return inner.value;
                    }else
                    return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';
                }
                return "";
            },

            employeeSummary() {
                this.$modal.show('employeeSummary');
            },

            hideModal() {
                this.$modal.hide();
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getConflictDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'DD MMM');
            },

            checkTurnOver(calls){
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length>=2 && Number(duration[0]) <= 24){
                        let hours =  Number(duration[0]);
                        if(hours < this.turnoverTime){
                            return true;
                        }
                    }
                }
                return false;
            },

            getPrevCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Last call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Last call 24:00+";
            },
            getPrevCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextCallDateTime(dateTime) {
                let result = "24:00+"
                if(dateTime&&dateTime!='') {
                    result = this.getGloabalDateTimeFormat(dateTime)
                }
                return result;
            },
            getNextVacationAndCallTime(vacation,calls) {
                let result1 = '';
                let result2 = '';
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result1 =  'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                if(vacation && Object.keys(vacation).length){
                    let duration = vacation[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result2 = 'Next vacation: '+moment(vacation[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return result1 + ', ' + result2;
            },

            getNextVacationTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next vacation '+moment(calls[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },
            getNextCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },

            // removed the unused code for unavailability on 02-02-2023 20:30:00
            recurringUnavailability(unavailability_list) {
                var flag=false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            var temp = unavailabilityList1[j];
                            var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOvernightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(isOvernightUnavailability) {
                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                let day1UnavailabilityStart = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay1UnavailabilityEnd = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '23:59:59';
                                let day1UnavailabilityEnd = moment(tempDay1UnavailabilityEnd, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay2UnavailabilityStart = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '00:00:00';
                                let day2UnavailabilityStart = moment(tempDay2UnavailabilityStart, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let day2UnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[i],temp);
                                if(flag) return flag;

                                let dayIndex = i;
                                if(i==6) dayIndex=-1;

                                // #1680 — an overnight RU window's DAY-1 portion belongs to its
                                // OWN weekday (already checked above under weekDaysNames[i]); only
                                // the genuine DAY-2 spillover (00:00 → wrap) carries the next-day
                                // label. The removed check re-tested the day-1 range under the
                                // next-day label, so e.g. a Friday ["04:55","01:00"] block made a
                                // Saturday daytime call unselectable (green tile, no checkbox).
                                // Now matches backend RecurringUnavailabilityCheck.
                                flag = this.checkCallDateUnavailability(day2UnavailabilityStart, day2UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;
                            }else {
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                                    let day1CallStart = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let tempDay1CallEnd =  moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    let tempDay2CallStart =  moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let day2CallEnd = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                                        if(flag) return flag;
                                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                                        if(flag) return flag;
                                    }
                                }else {
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        if(flag) return flag;
                                    }
                                }
                            }
                        }
                    }
                }
                return flag;
            },

            checkCallDateUnavailability(start, end, callStartTime, callEndTime, day,temp) {
                let flag = false;
                if((moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                    let day1CallStart = moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let tempDay1CallEnd =  moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    let tempDay2CallStart =  moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let day2CallEnd = moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day){
                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                        if(flag) return flag;
                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                        if(flag) return flag;
                    }
                }else {
                    if(moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        flag = dateTimeConvert.dateCheck(start,end, callStartTime, callEndTime);
                        if(flag) return flag;
                    }
                }
                return flag;
            },

            recurringUnavailability1(unavailability_list){  //removed... not calling any where, just for reference
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.callStartTime).format('d');

                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.callEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';
                            if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },
            checkVacationWithinCall(vacations) {

                if(vacations.length>0){
                    return true;
                }else{
                    return false;
                }
            },
        },
        created() {
            switch(this.columnLabel){
                case "skill_seniority":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "shift_count_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shift_count_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_total":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "declines_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "shifts_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_cell_phone":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "employee_name":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "conflicts":
                    this.columnClass='calls-table-cell tcell_7'
                    break;
                case "shifts_ytd_july_june":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "location":
                    this.columnClass='calls-table-cell tcell_5'
                    break;
                case "decline_this_week":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "participation_july_june_desc":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "member_since":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "date_of_hire":
                    this.columnClass='calls-table-cell tcell_4'
                    break;

                case "last_offer":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_assigned":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "last_confirmed":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "wishlist":
                    this.columnClass='calls-table-cell tcell_3'
                    break;
                case "employee_seniority":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field1":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
                case "custom_field2":
                    this.columnClass='calls-table-cell tcell_4'
                    break;
            }
            this.turnoverTime = this.client.turnover;
            // this.selectedSortType = this.client.default_sort;
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
            this.showCustom = this.client.call_assignment_title;
            this.callAssigmentSettings = this.client.settings['call-assignment-config'];
        }

    }

</script>
<style scoped>
.o-common-modal-content {
    padding-bottom: 15px !important;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.u-btn-blue {
    background: #37bae8!important;
}

.u-btn-yellow1 {
    background: #e8e000bf!important;
}
.u-btn-text-red1 {
    color: red!important;
}
.u-btn-border-red {
    border: solid 5px red;
}
.o-half-div-width{
    width: auto;
}
</style>

<style>
.el-dialog.pass-time-out-modal {
    border: 2px solid #000000;
    border-radius: 5px;
}
.pass-time-out-modal .el-dialog__header {
    padding: 0;
    margin-top: 0px;
    /* display: none; */
    /* border-bottom: 2px solid #000000; */
}
.pass-time-out-modal .el-dialog__body {
    padding: 0;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 {
    padding: 20px 20px 0;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .employee-summary-profile{
    text-align: left;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .employee-summary-profile--inline{
    margin: 0;
}
.pass-time-out-modal .el-dialog__body .o-ndividualTable {
    padding: 0 20px 10px!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .c-common-space {
    margin-bottom: 0!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-inline-datepicker-icon {
    width: 160px!important;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-schedule-month a {
    /* font-size: 18px; */
    /* color: #4D7FAE; */
    margin-left: 2px;
}
.pass-time-out-modal .el-dialog__body .o-main-content-area2 .o-filter-area {
    margin-right: 32px;
}
.pass-time-out-modal .el-dialog__body .o-ndividualTable .o-schedule-table {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn {
    top: 0;
    right: 0;
    padding: 10px;
    background-color: #fc3b3b;
    color: #ffffff;
    z-index: 999;
}

.pass-time-out-modal .el-dialog__header .el-dialog__title {
    display: none;
    /* font-size: 24px; */
    /* color: #000000; */
    /* font-weight: bold; */
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn .el-icon-close {
    color: #ffffff;
    font-weight: bold;
}
.pass-time-out-modal .el-dialog__header .el-dialog__headerbtn .el-icon-close:hover {
    color: #ffffff!important;
    font-weight: bold;
}
/* .pass-time-out-modal {
    border: 2px solid #000000;
    border-radius: 5px;
} */
</style>
